import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { useAtom, useAtomValue } from 'jotai';
import { Cell, Pie, PieChart, Tooltip } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { ContentType } from 'recharts/types/component/Tooltip';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { activeHolderAtom } from './TopTenHolders';

const CustomTooltip: ContentType<ValueType, NameType> = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const address = payload[0].name as string;
    const label =
      address !== 'Others'
        ? `${address.slice(0, 3)}...${address.slice(address.length - 3, address.length)}`
        : address;
    const percentage = payload[0].value as number;
    return (
      <div className="hidden sm:flex rounded-md border border-[rgb(34,50,83)] bg-gray-900 px-3 py-1">
        <p className="text-white">{`${label}: ${Number(percentage).toFixed(2)}%`}</p>
      </div>
    );
  }

  return null;
};

export const COLORS = [
  '#8B5CF6',
  '#3B82F6',
  '#F59E0B',
  '#10B981',
  '#EF4444',
  '#EC4899',
  '#6366F1',
  '#F97316',
  '#14B8A6',
  '#A855F7',
  '#22D3EE',
];

export const LiquidityGraph = () => {
  const tokenInfoResult = useAtomValue(tokenInfoAtom);
  const [activeHolder, setActiveHolder] = useAtom(activeHolderAtom);

  if (!tokenInfoResult) return;

  const topHolderPercentage = tokenInfoResult.top_ten_per;
  const pieData = [
    // { name: 'Top Holders', value: topHolderPercentage },
    ...tokenInfoResult.top_ten_holders.map(holder => ({
      name: holder.address,
      value: Number(holder.percentage),
    })),
    { name: 'Others', value: 100 - topHolderPercentage },
  ];

  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle>Total Value</CardTitle>
        <CardDescription>
          <span className="text-3xl font-bold text-white">${tokenInfoResult.mc_str} USD</span>
        </CardDescription>
      </CardHeader>

      <CardContent className="flex items-center justify-center">
        <PieChart width={260} height={260}>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="90%"
            paddingAngle={1}
            startAngle={0}
            endAngle={360}
            dataKey="value"
            animationBegin={0}
            animationDuration={1200}
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index]}
                strokeWidth={1}
                stroke="#2D3648"
                onMouseEnter={() => {
                  setActiveHolder(entry.name);
                }}
                onMouseLeave={() => {
                  setActiveHolder(null);
                }}
                opacity={activeHolder === null || activeHolder === entry.name ? 1 : 0.6}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </CardContent>
    </Card>
  );
};
